import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the window to (0, 0) on every route change — but respects URL
 * hashes (#section-id). When a link like `/services#warranty` is followed,
 * we wait a tick for the DOM to render then scroll the target into view.
 *
 * Place this once inside <Router> and it fixes every page.
 */
function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer one frame so the target element exists by the time we look it up.
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        // Fallback: top of page if the anchor doesn't exist on this route.
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, search, hash]);

  return null;
}

export default ScrollToTop;
